import React from 'react';
import { useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import moment from 'moment';
import 'moment/min/locales';
import { useClassroomData } from 'data/useClassroomData';
import { JamCard, LabCard } from 'components';
import { isEmpty } from 'utils/helpers';
import './LabList.css';

const translateDurationUnit = (value, unit, locale) => {
    // crlalva: to match Content API duration enum
    // https://code.amazon.com/packages/BunsenContent/blobs/mainline/--/src/libraries/data/blueprintVersionEnums.js
    if (unit === 'min') {
        unit = 'minute';
    }
    return moment
        .duration(value, unit)
        .locale(locale)
        .humanize();
};

const LabList = () => {
    const { locale } = useIntl();
    const { classroomId } = useParams();
    const { classData } = useClassroomData(classroomId);

    const labList = (classData.content || []).map((content, index) => ({
        ...content,
        index,
        title: content.title.replace(new RegExp(`^\\s*${classData.course.title}\\s*-\\s*`), ''),
        duration: translateDurationUnit(content.duration, content.durationUnit || 'minute', locale),
    }));

    const jamCards = (classData.jamTrainings?.trainings || []).map((training, index) => (
        <JamCard
            courseTitle={classData.course.title}
            jamIndex={index}
            jamTraining={training}
            key={training.contentId}
        />
    ));

    return isEmpty(classData) ? null : (
        <ol data-testid="lab-list" className="lab-list">
            {labList.map(lab => (
                <LabCard {...lab} key={lab.title} />
            ))}
            {jamCards}
        </ol>
    );
};
export default LabList;
